import React, {useImperativeHandle, useRef, forwardRef, useState} from "react";

import InputPassword from "../2_widgets/inputs/InputPassword";

/* Props
*  isReadOnly   : bool, set to true if input shouldn't be modified
*/
const PasswordConfirmationInputGroup = forwardRef( function PasswordConfirmationInputGroup({isRequired, isReadOnly=false}, ref) {
    const [displayErrors, setDisplayErrors] = useState(false);

    const refInputPassword = useRef();
    const refInputConfirmation = useRef();
    

    useImperativeHandle(ref, ()=>({
        getValue() {
            let password = refInputPassword.current.getValue();
            let confirmation = refInputConfirmation.current.getValue();
            return {password: password, confirmation: confirmation};
        },
        hasErrors() {
            return hasErrors();
        },
        displayErrors() {            
            if (hasErrors()) {
                setDisplayErrors(true);
            }
            displayPasswordsDoesntMatchMessage();
        },
        resetValue() {            
            refInputPassword.current.resetValue();
            refInputConfirmation.current.resetValue();
        }
    }));

    /**
     * Check if there is an error in this input
     */
    function hasErrors() {
        let password = refInputPassword.current.getValue()?.trim();
        let confirmation = refInputConfirmation.current.getValue()?.trim();

        return (
            refInputPassword.current.hasErrors() ||
            refInputConfirmation.current.hasErrors() ||
            password !== confirmation
        );
    }

    function callbackBlur(error) {
        let password = refInputPassword.current.getValue()?.trim();
        let confirmation = refInputConfirmation.current.getValue()?.trim();
        
        setDisplayErrors(error.error || password !== confirmation);
    }

    function displayPasswordsDoesntMatchMessage(isOnError) {
        if (isOnError) {
            return (
                <p className="input-error-message">Les champs ne correspondent pas. Veuillez recommencer</p>
            )
        }
    }

    return (
        <>
            <InputPassword
                ref={refInputPassword}
                label="Mot de passe (minimum 8 caractères dont au moins 1 chiffre, 1 minuscule, 1 majuscule, 1 caractère spécial)" 
                inputId="input-password"
                controlPasswordFormat={true} 
                isRequired={isRequired} 
                isReadOnly={isReadOnly} 
            />
            <InputPassword 
                ref={refInputConfirmation} 
                label="Confirmation du mot de passe" 
                inputId="input-password-confirmation" 
                isRequired={isRequired} 
                isReadOnly={isReadOnly} 
                callbackBlur={callbackBlur}
            />
            {displayPasswordsDoesntMatchMessage(displayErrors)}
        </>
    )
})
export default PasswordConfirmationInputGroup;